import { render, staticRenderFns } from "./ActiveEventPanel.vue?vue&type=template&id=53a363b3&"
import script from "./ActiveEventPanel.vue?vue&type=script&lang=js&"
export * from "./ActiveEventPanel.vue?vue&type=script&lang=js&"
import style0 from "./ActiveEventPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports